import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => ({
	badgesContainer: {
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		padding: "20px",
		gap: "10px",
	},

	header: {
		textAlign: "center",
		padding: "0 20px 20px 20px",
		cursor: "pointer",
	},

	title: {
		fontWeight: "bold",
		color: "#333333",
		marginBottom: "8px",
	},

	subtitle: {
		color: "#666666",
		lineHeight: "1.4",
	},

	buttonsContainer: {
		padding: "0 20px 20px 20px",
		display: "flex",
		flexDirection: "column",
		gap: "12px",
	},

	button: {
		backgroundColor: "transparent",
		color: "#222",
		border: "1px solid #222",
		width: "100%",
		padding: "8px",
		borderRadius: "100px",
		textTransform: "none",
		fontWeight: "bold",
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		gap: "8px",
		"&:hover": {
			backgroundColor: "#672E37",
			color: "white",
		},
		"&:disabled": {
			backgroundColor: "#f5f5f5",
			color: "#999999",
			border: "1px solid #cccccc",
			cursor: "not-allowed",
			opacity: 0.7,
		},
	},

	icon: {
		marginRight: 8,
		fontSize: 20,
	},
}));
